export enum greetingCardAnalyticsEvent {
  CardOpen = 'card_open',
  CardSent = 'card_sent',
  TapReply = 'tap_reply',
  TapBanner = 'tap_banner',
}
